import React from 'react';
import PropTypes from 'prop-types';

export default function CheckIcon(props) {
  const { fill, size } = props;

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 10.83 8'>
      <path
        fill={fill}
        d='M3.064 7.764a.811.811 0 0 0 1.144 0l6.384-6.384A.808.808 0 0 0 9.449.238L3.637 6.05 1.379 3.792A.808.808 0 0 0 .237 4.934Z'
        data-name='Caminho 12466'
      />
    </svg>
  );
}

CheckIcon.defaultProps = {
  size: '20',
  fill: '#4b4b4b'
};

CheckIcon.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.string
};
